function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99989 8.76929V11.077L3.23066 12.4616L0.461426 15.6924L1.3845 16.6154L4.15373 14.3077L7.84604 12.4616L9.69219 9.23083L5.99989 8.76929Z",
  fill: "#966342"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0771 10.1539L19.3848 15.2308L21.6925 18.0001H22.6156L20.3079 12.9232L19.3848 9.69238L17.0771 10.1539Z",
  fill: "#966342"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7692 6.923L25.6154 8.07685L24.6156 7.2305L23.2639 6.08704L22.6154 5.53839L20.3077 7.84608V10.6153L18 11.5384L16.7487 11.7657L14.7727 12.1251C14.1919 12.2305 13.5952 12.2102 13.0229 12.0656C12.4506 11.921 11.9159 11.6554 11.4548 11.2868C11.1392 11.0344 10.7881 10.8299 10.4129 10.6799C10.1364 10.5683 9.84855 10.4874 9.55441 10.4388L7.84615 10.1538L6.46154 8.30762L5.73519 8.48935C5.5456 8.53709 5.36295 8.60902 5.19173 8.70339C4.73535 8.95485 4.3802 9.35668 4.18673 9.8405C4.03699 10.215 3.78958 10.5426 3.47027 10.7891C3.15096 11.0355 2.77141 11.1919 2.37116 11.2418L0 11.5384L2.13462 9.75973C2.5495 9.41405 2.85977 8.95953 3.03058 8.44723C3.22318 7.86895 3.5929 7.36596 4.08735 7.00954C4.58179 6.65313 5.17587 6.46138 5.78538 6.46146H6.46154L7.61538 6.07666C8.59253 5.7511 9.65203 5.77229 10.6154 6.13666C10.676 6.15916 10.736 6.18396 10.796 6.20935C11.8643 6.66694 13.0687 6.69156 14.1548 6.278L15.6923 5.69242L21.9173 3.32069L22.1538 3.23069H22.8462L22.6154 2.30762L24.4615 3.23069L24.8163 3.79896L26.059 5.78704L26.7692 6.923Z",
  fill: "#AD7D4D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0771 4.15379C22.8396 4.21316 22.5883 4.17576 22.3784 4.04982C22.1685 3.92388 22.0172 3.71972 21.9579 3.48225L21.9175 3.32071L22.154 3.23071H22.8463L23.0771 4.15379Z",
  fill: "#966342"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.413 10.6799C10.1366 10.5683 9.84872 10.4874 9.55458 10.4388L7.84632 10.1538L6.4617 8.3076L5.73535 8.48933C5.54577 8.53707 5.36311 8.609 5.19189 8.70337C5.32583 8.18514 5.57423 7.70352 5.91882 7.29395L9.79343 7.93952L10.0075 8.3676C10.3641 9.08272 10.505 9.88612 10.413 10.6799Z",
  fill: "#966342"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.46176 7.38452C5.87073 7.97556 5.53869 8.77717 5.53869 9.61302V9.7714C5.53869 10.1853 5.6202 10.5951 5.77859 10.9775C5.93697 11.3598 6.16911 11.7073 6.46176 11.9999L5.07715 13.3845L6.46176 17.9999H7.38484L6.9233 14.7691L8.91244 12.78C9.4211 12.2713 9.76781 11.6235 9.90889 10.9181C10.0678 10.1236 9.95734 9.29875 9.59498 8.57402L9.23099 7.84606L6.46176 7.38452Z",
  fill: "#AD7D4D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3077 8.54938V10.6153L18 11.5384L16.7487 11.7657C16.4295 11.3385 16.1987 10.8519 16.0697 10.3344L15.7402 9.01726L18.9196 7.10938C19.5032 7.45606 19.9827 7.95347 20.3077 8.54938Z",
  fill: "#966342"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1538 8.76914L16.5172 10.2226C16.684 10.8899 17.0397 11.495 17.5417 11.9653C18.0437 12.4356 18.6706 12.7512 19.3474 12.8743L22.1538 13.3845L24.923 15.6922L26.7692 15.2307L23.0769 11.5384L20.3077 10.6153V10.3717C20.3077 9.75143 20.1349 9.14346 19.8089 8.61586C19.4828 8.08827 19.0162 7.66189 18.4615 7.38452L16.1538 8.76914Z",
  fill: "#AD7D4D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0589 5.78715L24.6154 7.23061L23.2637 6.08715L23.9998 4.61542L24.8162 3.79907L26.0589 5.78715Z",
  fill: "#E44B4D"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6922 5.69238V9.23065H10.6152V6.13661C10.6758 6.15911 10.7358 6.18392 10.7958 6.20931C11.8642 6.6669 13.0685 6.69152 14.1547 6.27796L15.6922 5.69238Z",
  fill: "#E44B4D"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5386 1.84619H15.231V2.76927H17.3079L17.5386 1.84619Z",
  fill: "#F2C194"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4615 1.38462V1.15385C18.4615 0.847827 18.3399 0.554342 18.1235 0.337954C17.9072 0.121566 17.6137 0 17.3077 0C17.0016 0 16.7081 0.121566 16.4918 0.337954C16.2754 0.554342 16.1538 0.847827 16.1538 1.15385V1.38462H18.4615Z",
  fill: "#E44B4D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M16.1538 1.38452V1.61529C16.1538 1.92131 16.2754 2.2148 16.4918 2.43118C16.7081 2.64757 17.0016 2.76914 17.3077 2.76914C17.6137 2.76914 17.9072 2.64757 18.1235 2.43118C18.3399 2.2148 18.4615 1.92131 18.4615 1.61529V1.38452H16.1538Z",
  fill: "#F4CEAF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4236 5.88281L15.2309 6.46147L11.5219 4.7757C11.3597 4.70219 11.2165 4.59258 11.1032 4.45526C10.9898 4.31794 10.9094 4.15652 10.868 3.98335C10.8266 3.81018 10.8253 3.62984 10.8642 3.4561C10.9032 3.28236 10.9813 3.11981 11.0927 2.98089C11.3645 2.64084 11.6964 2.35342 12.0717 2.13281L12.4617 3.69224L14.9119 4.74224C15.1248 4.8334 15.2956 5.00132 15.3904 5.21263C15.4852 5.42393 15.4971 5.66317 15.4236 5.88281Z",
  fill: "#D3E1E9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0427 4.74927L18.8495 4.78158L17.0772 5.07697L15.4156 3.69235H12.4618L12.0718 2.13235C12.0718 2.13235 12.9539 1.72735 13.442 1.6662L14.9235 1.48101C15.1585 1.45149 15.3971 1.48277 15.6165 1.57187C15.8359 1.66096 16.0287 1.80488 16.1766 1.98985L17.5387 3.69235L18.516 3.44774L18.7595 3.38716C18.8147 3.37319 18.8715 3.36622 18.9285 3.36639C19.1031 3.3665 19.2714 3.43224 19.3998 3.55058C19.5283 3.66892 19.6075 3.83122 19.6219 4.00527C19.6363 4.17933 19.5847 4.35243 19.4774 4.49024C19.3702 4.62805 19.215 4.72051 19.0427 4.74927H19.0427Z",
  fill: "#8ACCE7"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9232 1.84617H16.1539C16.0315 1.84617 15.9141 1.79755 15.8276 1.71099C15.741 1.62444 15.6924 1.50704 15.6924 1.38463C15.6924 1.26223 15.741 1.14483 15.8276 1.05828C15.9141 0.971722 16.0315 0.923096 16.1539 0.923096H18.9232C19.0456 0.923096 19.163 0.971722 19.2495 1.05828C19.3361 1.14483 19.3847 1.26223 19.3847 1.38463C19.3847 1.50704 19.3361 1.62444 19.2495 1.71099C19.163 1.79755 19.0456 1.84617 18.9232 1.84617Z",
  fill: "#D14547"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5201 5.68384L12 9.23065H14.7692L13.8462 8.30757L15.2308 6.46141L13.5201 5.68384Z",
  fill: "#395166"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4153 3.69236H13.9735L13.7168 3.47833L14.3076 2.76929L15.4153 3.69236Z",
  fill: "#379EC3"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0423 4.7491L18.8491 4.78141L18.5156 3.44756L18.7591 3.38698C18.8143 3.37302 18.8711 3.36604 18.9281 3.36621C19.1028 3.36632 19.271 3.43207 19.3994 3.55041C19.5279 3.66875 19.6071 3.83104 19.6215 4.0051C19.6359 4.17915 19.5843 4.35225 19.4771 4.49007C19.3698 4.62788 19.2146 4.72034 19.0424 4.7491H19.0423Z",
  fill: "#F4CEAF"
});

var SvgHorse = function SvgHorse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHorse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/horse.c6808d3d.svg";
export { ForwardRef as ReactComponent };